<div class="modal modal__sm text-center" data-e2e-element="verification-modal">
  <h3 class="title-xl" [translate]="'verification-modal.title.' + data.type"></h3>
  <p class="fz-12" [translate]="'verification-modal.text.' + data.type"></p>
  <button [mat-dialog-close]="" class="button button--wide">
    <div class="button__wrapper">
      <span translate="verification-modal.btn"></span>
    </div>
  </button>
</div>
